import { handleChoiceField } from "../../prefill/helpers";
import type { FieldRegistryConfig } from "../../types";
import { SingleSelectFieldControl } from "../single-select/SingleSelectFieldControl/SingleSelectFieldControl";
import type { SingleSelectFieldValue } from "../single-select/single-select.config";

export interface StatusFieldValue {
  value: string;
  label: string;
}

export const statusFieldConfig: FieldRegistryConfig<SingleSelectFieldValue, StatusFieldValue> = {
  icon: "status",
  control: SingleSelectFieldControl,
  convertFormValueToApi: (value) => ({ value, label: "" }),
  prefill: ({ value, field }) => handleChoiceField(value, field.params.choices),
  toReviewString: (value, appField) => {
    const matchedChoice = appField.params.choices?.find((choice) => choice.value === value);
    return matchedChoice?.label ?? "";
  },
};
